import vue from "../main";

export default function() {
  let types = [
    {
      id: 3001,
      name: vue.$t("$staticData.otherSummaryTypes.representativeCosts")
    },
    {
      id: 3002,
      name: vue.$t("$staticData.otherSummaryTypes.advertisingCosts")
    },
    { id: 3003, name: vue.$t("$staticData.otherSummaryTypes.meal") },
    { id: 3004, name: vue.$t("$staticData.otherSummaryTypes.transport") },
    { id: 3005, name: vue.$t("$staticData.otherSummaryTypes.accommodation") }
    //{id: 3006, name: "Bilety wejściowe "}, udział w targach zaliczany moze byc do kosztow
  ].sort((a, b) => (a.name > b.name ? 1 : -1));
  types.push({ id: 3000, name: vue.$t("$staticData.otherSummaryTypes.other") });
  return types;
}
